module.exports = "pegasus/assets/backdrop.png";